import { create } from 'zustand'
import type { ISoundPlayer } from '@/features/scanner/alerts/audio/sound-player'

/**
 * The app's unlocked sound player, registered by AlertWindowNotifier so a live
 * alert-window fire can play through it. The mute setting is per panel and
 * lives in `alert-window-audio.ts`. Its own store (not the Price Alerts one)
 * so the two features register players independently.
 */
interface AlertWindowSoundState {
  player: ISoundPlayer | null
  setPlayer: (player: ISoundPlayer | null) => void
}

export const useAlertWindowSoundStore = create<AlertWindowSoundState>((set) => ({
  player: null,
  setPlayer: (player) => set({ player }),
}))
